import {
    FETCH_HAS_LOTTERY_TEMPLATE,
    LIST_HAS_LOTTERY_TEMPLATE,
    MODIFY_HAS_LOTTERY_TEMPLATE,
    CLEAR_HAS_LOTTERY_TEMPLATE, CREATE_HAS_LOTTERY_TEMPLATE
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_HAS_LOTTERY_TEMPLATE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_HAS_LOTTERY_TEMPLATE:
            return {
                ...state,
                isLoading: false,
                list: payload
            };
        case CREATE_HAS_LOTTERY_TEMPLATE:
        case MODIFY_HAS_LOTTERY_TEMPLATE:
            return {
                ...state,
                isLoading: true
            };
        case CLEAR_HAS_LOTTERY_TEMPLATE:
            return {
                ...init
            };
        default:
            return state;
    }
}